export default {
  strict: true,
  namespaced: true,
  state: {
    userInfo: {},
    formHasError: false,
    formLoading: false,
    formSave: {
      isDone: false,
      message: ''
    },
    triggerStatusUpdate: false,
    selectedStatus: 'activate'
  },
  mutations: {
    resetUserInfo (state, value) {
      state.userInfo = {}
      state.formHasError = false
      state.formLoading = false
      state.formSave = {
        isDone: false,
        message: ''
      }
    },
    setuserInfo (state, value) { state.userInfo = value },
    setuserActive (state, value) { state.userInfo.enabled = value },
    setFormHasError (state, value) { state.formHasError = value },
    setFormLoading (state, value) { state.formLoading = value },
    setFormSavingDone (state, value) { state.formSave.isDone = value },
    setFormSaveMessage (state, value) { state.formSave.message = value },
    setTriggerStatusUpdate (state, value) { state.triggerStatusUpdate = value },
    setSelectedStatus (state, value) { state.selectedStatus = value },
    setuserInfoData (state, data) {
      for (let field in data) {
        state.userInfo[field] = data[field]
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/consumer/user-info.js